import React from 'react';
import enJson from './locales/en';
import zhJson from './locales/zh-hans-cn';
import twJson from './locales/zh-hant-tw';
import thJson from './locales/th';
import viJson from './locales/vi';
import idJson from './locales/id';
var languageInfos = [{
  name: 'zh-hans-cn',
  value: zhJson
}, {
  name: 'zh-hant-tw',
  value: twJson
}, {
  name: 'en',
  value: enJson
}, {
  name: 'th',
  value: thJson
}, {
  name: 'vi',
  value: viJson
}, {
  name: 'id',
  value: idJson
}];
var language = languageInfos[0].name;
var getDefault = function getDefault(key) {
  if (key && key.split('.').length) {
    var names = key.split('.').filter(Boolean);
    return names[names.length - 1];
  }
  return key;
};
var getTargetJson = function getTargetJson() {
  var _languageInfos$find;
  return ((_languageInfos$find = languageInfos.find(function (item) {
    return item.name === language;
  })) === null || _languageInfos$find === void 0 ? void 0 : _languageInfos$find.value) || zhJson;
};
var getValue = function getValue(_ref) {
  var key = _ref.key,
    params = _ref.params;
  var value = getTargetJson()[key] || getDefault(key);
  if (params) {
    return value.replace(/\{\{.*?\}\}/g, function (target) {
      var param = target.replace(/(\{\{)|(\}\})/g, '').trim();
      return params[param];
    });
  }
  return value;
};
export var getLanguage = function getLanguage() {
  return language;
};
export var changeLanguage = function changeLanguage(lang) {
  if (language !== lang) {
    language = lang;
    Array.from(document.querySelectorAll('.one-admin-components-i18n')).forEach(function (item) {
      item.innerHTML = getValue(JSON.parse(item.getAttribute('placeholder')));
    });
  }
};
export var i18n = function i18n(key, params) {
  return /*#__PURE__*/React.createElement("span", {
    key: key,
    className: "one-admin-components-i18n",
    placeholder: JSON.stringify({
      key: key,
      params: params
    })
  }, getValue({
    key: key,
    params: params
  }));
};
export default changeLanguage;